module.exports = __webpack_public_path__ + "assets/images/walk_support_g.5c27b2e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/walk_support_g.png
// module id = 774
// module chunks = 1